import { useEffect, useState } from "react";
import { Search as SearchIcon, X } from "lucide-react";
import { api } from "@/lib/api";
import ProstoHeader from "@/prosto/ProstoHeader";
import ProstoAppRow from "@/prosto/ProstoAppRow";
import LoadError from "@/components/LoadError";
import { apiErrorMessage } from "@/lib/apiResponses";

export default function ProstoSearch() {
  const [q, setQ] = useState("");
  const [apps, setApps] = useState([]);
  const [status, setStatus] = useState("loading");
  const [error, setError] = useState(null);
  const [retry, setRetry] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    setStatus("loading");
    setError(null);
    setApps([]);
    const t = setTimeout(async () => {
      try {
        const result = await api.apps(q ? { search: q } : {}, { signal: controller.signal });
        if (!controller.signal.aborted) {
          setApps(result);
          setStatus("success");
        }
      } catch (e) {
        if (!controller.signal.aborted) {
          setError(apiErrorMessage(e));
          setStatus("error");
        }
      }
    }, 200);
    return () => { clearTimeout(t); controller.abort(); };
  }, [q, retry]);

  return (
    <div className="pb-20">
      <ProstoHeader title="Поиск" back />
      <div className="px-4 pt-4">
        <div className="flex items-center gap-3 px-4 py-3 rounded-2xl bg-slate-100">
          <SearchIcon size={18} className="text-slate-400" />
          <input
            data-testid="prosto-search-field"
            autoFocus
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Какое приложение нужно?"
            className="flex-1 bg-transparent outline-none text-[15px] text-slate-900 placeholder:text-slate-400"
          />
          {q && (
            <button data-testid="prosto-search-clear" onClick={() => setQ("")} className="text-slate-400">
              <X size={18} />
            </button>
          )}
        </div>

        <div className="mt-4 divide-y divide-slate-100">
          {status === "loading" ? (
            <div className="py-10 text-center text-slate-400" role="status">Загрузка…</div>
          ) : status === "error" ? (
            <LoadError message={error} onRetry={() => setRetry((n) => n + 1)} testId="prosto-search-error" />
          ) : apps.length === 0 ? (
            <div className="py-10 text-center text-slate-400">Ничего не найдено.</div>
          ) : (
            apps.map((app) => <ProstoAppRow key={app.id} app={app} />)
          )}
        </div>
      </div>
    </div>
  );
}
